import React, { useContext } from 'react';
import { Context } from 'components/Store';
import GrowUIFormField from 'components/Forms/GrowUIFormField';
import { Input } from '@agconnections/grow-ui';

const FSAArea = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <GrowUIFormField
      control={Input}
      placeholder="Enter area"
      type="text"
      name="fsaArea"
      label="FSA Area"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default FSAArea;
